import { ReactNode } from 'react';

import { createPortal } from 'react-dom';

type Children = {
  children: ReactNode;
};

const ModalPortal = ({ children }: Children) => {
  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  return createPortal(children, modalRoot);
};

export default ModalPortal;
